import { useState } from 'react';
import { Box, Typography, Alert } from '@mui/material';
import ConfigCard from '../shared/ConfigCard';
import useEnumStatuses from '../../hooks/useEnumStatuses';

function EnumerationTab() {
  const { 
    enumStatuses, 
    error: statusError,
    updateStatus 
  } = useEnumStatuses();
  
  const [loadingEnums, setLoadingEnums] = useState({});
  const [enumError, setEnumError] = useState(null); 

  const handleEnumToggle = async (enumName) => {
    setEnumError(null);
    const isCurrentlyEnabled = enumStatuses[enumName]?.enabled;

    setLoadingEnums(prev => ({ 
      ...prev, 
        [enumName]: true 
    }));

    const success = await updateStatus(enumName, !isCurrentlyEnabled);
    
    if (!success) {
      setEnumError(`Failed to ${isCurrentlyEnabled ? 'disable' : 'enable'} ${enumName}`);
    }
    
    setLoadingEnums(prev => ({ 
      ...prev, 
      [enumName]: false 
    }));
  };


  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        Enumeration Configurations
      </Typography>
      
      {(enumError || statusError) && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {enumError || statusError}
        </Alert>
      )}
      
      <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
        General Configurations
      </Typography>
      {Object.keys(enumStatuses)
        .map((enumName) => (
          <ConfigCard
            key={enumName}
            title={enumName}
            enabled={enumStatuses[enumName]?.enabled || false}
            loading={loadingEnums[enumName]}
            onToggle={() => handleEnumToggle(enumName)}
          />
        ))}
    </Box>
  );
}

export default EnumerationTab; 